import Layout from '../components/Layout';
import BookUploadForm from '../components/BookUploadForm';

export default function BookUploadPage() {
  return (
    <Layout>
      <BookUploadForm />
    </Layout>
  );
}
